import { FormWithShiftInfo } from './types'

export const ScanCsvCell = (rowData: FormWithShiftInfo) => rowData.scan_number

export const PacketCsvCell = (rowData: FormWithShiftInfo) => rowData.shift.name

export const RegistrantCsvCell = (rowData: FormWithShiftInfo) =>
  rowData.display_name

export const CountyCsvCell = (rowData: FormWithShiftInfo) => rowData.county

export const CollectedCsvCell = (rowData: FormWithShiftInfo) =>
  rowData.shift.shift_start

export const UploadedCsvCell = (rowData: FormWithShiftInfo) =>
  rowData.created_at
